export type LocationSuggestion = {
  label: string
  city: string
  lat: number
  lng: number
}

export type LocationSelection = {
  name: string
  address: string
  latitude: number
  longitude: number
}

export type LocationSearchInputProps = {
  enabled?: boolean
  disabled?: boolean
  onSelect: (place: LocationSelection) => void
}

export const GEOCODE = {
  searchLimit: 8,
  searchDebounceMs: 350,
  minQueryLength: 2,
} as const

export const LOCATION_SEARCH = {
  label: 'Search location',
  placeholder: 'Search area, landmark, or address…',
  hint: 'Pick a result to fill address and coordinates.',
  searching: 'Searching…',
  empty: 'No matching places found.',
  failed: 'Location search is unavailable right now. Try again.',
} as const
